export enum EnumFiltroFechas{
    SEMANA_ACTUAL   = 1,
    SEMANA_ANTERIOR = 2,
    HOY             = 3,
    MES_ACTUAL      = 4,
    MES_ANTERIOR    = 5,
    RANGO_DE_FECHAS = 6,
}